import { Params } from "@angular/router";
import { ProjectTimeType } from "./project";

export const AppVersion = 2;

export class UserUIPreference {
    userId?: number;
    data?: string;
}

export class UIPreference {
    version?: number = AppVersion;
    timesheet?: TimesheetUIPreferences = new TimesheetUIPreferences();
    efforts?: TableUIPreferences = new TableUIPreferences();
    projects?: TableUIPreferences = new TableUIPreferences();
    users?: UserManagementPreferences = new UserManagementPreferences();
    submissions?: SubmissionsUIPreferences = new SubmissionsUIPreferences();
    accessibility?: AccessibilityPreferences = new AccessibilityPreferences();
}

export type Timer = { startedAt: Date, hoursAtStart: number };
export type Timers = { [day: string]: { [proj: string]: Timer } };

export class TimesheetUIPreferences {
    expandedEffortIds?: number[] = [];
    expandedProjectIds?: number[] = [];
    pinnedProjectTimeTypes?: ProjectTimeTypeShort[] = [];
    daysToHide?: WeekDayAbbr[] = [];
    hideHelper?: boolean | number = false;
    daysOff?: WeekDayAbbr[] = [];
    confirmTSSubmit?: boolean = false;
    allowTwoDigitEntry?: boolean = false;
    enableColTools?: boolean = true;
    enableRowTools?: boolean = true;
    areTimersPersisted?: boolean = true;
    persistedTimers?: Timers = {};
    lastWeekViewed?: string = undefined;
    defaultTimesheetWeek?: "current-week" | "last-opened" | "oldest-unsubmitted" = "oldest-unsubmitted";
    hoursRoundingMethod?: "down" | "up" | "nearest" = "down";
    tsCellToolLocation?: "context-menu" | "active-bottom" | "persistent-right" = "context-menu";
}

export class AccessibilityPreferences {
    iconBtnPersistence?: "transient" | "persistent" = "transient";
    themePersistence?: "api" | "local" | "";
    isDarkMode?: boolean = false;
}

export class TableUIPreferences {
    pageSize: number = 10;
    displayedColumns: string[] = [];
    columnOrder: string[] = [];
}

export class UserManagementPreferences extends TableUIPreferences {
    recentADGroups: string[] = [];
}

export class SubmissionsUIPreferences extends TableUIPreferences {
    month: number = 0;
    lastFilterQueryString: string = "";
    savedQueryStrings: [string, Params][] = [];
    notifyReviewByEmail: boolean = false;
    notifyAcceptedByEmail: boolean = false;
    dateRangePreset?: SubmissionDateRangePreset = "this-month";
}

export type SubmissionDateRangePreset = "this-week" | "last-week" | "this-month" | "last-month" | "last-3-months" | "since-epoch";

export interface ProjectTimeTypeShort {
    projectId: number;
    timeTypeId: number;
}

export type WeekDayAbbr = 'sun'|'mon'|'tue'|'wed'|'thu'|'fri'|'sat';
